import { useState } from "react";
import { Typography, Box, Card, CardContent, Tabs, Tab } from "@mui/material";
import {
  Groups as GroupsIcon,
  Share as ShareIcon,
  Lock as LockIcon,
} from "@mui/icons-material";
import UserSharedDives from "./UserSharedDives";
import UserRelatedDives from "./UserRelatedDives";
import UserNonSharedDives from "./UserNonSharedDives";

/**
 * Main component for displaying all dives on a profile page
 * Provides tabs to switch between user's shared dives, non-shared dives, and related dives
 */
export default function SharedDivesSection({ userId }) {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Card elevation={3}>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          Your Dives
        </Typography>

        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="dive navigation tabs"
          variant="fullWidth"
          sx={{ mb: 2 }}
        >
          <Tab
            icon={<ShareIcon fontSize="small" />}
            iconPosition="start"
            label="Shared"
            id="tab-0"
            aria-controls="tabpanel-0"
          />
          <Tab
            icon={<LockIcon fontSize="small" />}
            iconPosition="start"
            label="Individual"
            id="tab-1"
            aria-controls="tabpanel-1"
          />
          <Tab
            icon={<GroupsIcon fontSize="small" />}
            iconPosition="start"
            label="Related"
            id="tab-2"
            aria-controls="tabpanel-2"
          />
        </Tabs>

        {tabValue === 0 && <UserSharedDives userId={userId} />}
        {tabValue === 1 && <UserNonSharedDives userId={userId} />}
        {tabValue === 2 && <UserRelatedDives userId={userId} />}
      </CardContent>
    </Card>
  );
}
